/**
 * One Million Sold — mobile (≤743px): scroll-triggered face groups, no scroll lock.
 * Group 1 reveals as collage enters viewport; group 2 after scrolling further.
 * Each group animates once per page load (no reset on scroll up or leaving viewport).
 */
(function () {
  var MOBILE_MQ = '(max-width: 743px)';
  var GROUP1_TOP_RATIO = 0.82;
  var GROUP2_TOP_RATIO = 0.52;
  var ENTRY_MS = 650;
  var BOUNCE_MS = 950;
  var AMP = 0.12;
  var FREQ = 4;
  var DECAY = 20;
  var VELOCITY = 1;
  var ROT_BOUNCE_MULT = 10;
  var START_ROT_MAX = 30;
  var ENTRY_Y_START = 0;
  var ENTRY_SCALE_START = 0.15;
  var STAGGER_MS = 28;

  function createCubicBezier(x1, y1, x2, y2) {
    var cx = 3 * x1;
    var bx = 3 * (x2 - x1) - cx;
    var ax = 1 - cx - bx;
    var cy = 3 * y1;
    var by = 3 * (y2 - y1) - cy;
    var ay = 1 - cy - by;

    function sampleX(t) {
      return ((ax * t + bx) * t + cx) * t;
    }

    function sampleY(t) {
      return ((ay * t + by) * t + cy) * t;
    }

    function sampleDerivativeX(t) {
      return (3 * ax * t + 2 * bx) * t + cx;
    }

    return function (progress) {
      if (progress <= 0) return 0;
      if (progress >= 1) return 1;

      var t = progress;
      for (var i = 0; i < 8; i++) {
        var x = sampleX(t) - progress;
        var d = sampleDerivativeX(t);
        if (Math.abs(x) < 1e-6) break;
        if (Math.abs(d) < 1e-6) break;
        t -= x / d;
      }

      t = Math.max(0, Math.min(1, t));
      return sampleY(t);
    };
  }

  var easeEntry = createCubicBezier(0.22, 1, 0.36, 1);

  function setFaceVars(face, yPct, scale, rotDeg, opacity) {
    face.style.setProperty('--mso-anim-y', yPct + '%');
    face.style.setProperty('--mso-anim-scale', String(scale));
    face.style.setProperty('--mso-anim-rot', rotDeg + 'deg');
    face.style.setProperty('--mso-anim-opacity', String(opacity));
  }

  function hideFace(face) {
    face._msoAnimGen = (face._msoAnimGen || 0) + 1;
    setFaceVars(
      face,
      ENTRY_Y_START,
      ENTRY_SCALE_START,
      face._msoStartRot || 0,
      0
    );
  }

  function showFaceInstant(face) {
    face._msoAnimGen = (face._msoAnimGen || 0) + 1;
    face._msoRevealed = true;
    setFaceVars(face, 0, 1, 0, 1);
  }

  function animateFace(face, startRotDeg) {
    var gen = (face._msoAnimGen || 0) + 1;
    face._msoAnimGen = gen;
    var t0 = performance.now();

    function frame(now) {
      if (face._msoAnimGen !== gen) return;

      var elapsedMs = now - t0;
      var tSec = elapsedMs / 1000;

      if (elapsedMs <= ENTRY_MS) {
        var p = easeEntry(elapsedMs / ENTRY_MS);
        setFaceVars(
          face,
          ENTRY_Y_START * (1 - p),
          ENTRY_SCALE_START + (1 - ENTRY_SCALE_START) * p,
          startRotDeg * (1 - p),
          p
        );
        requestAnimationFrame(frame);
        return;
      }

      var tb = tSec - ENTRY_MS / 1000;
      var bounce =
        (VELOCITY * AMP * Math.sin(FREQ * tb * 2 * Math.PI)) /
        Math.exp(DECAY * tb);
      setFaceVars(face, 0, 1 + bounce, bounce * ROT_BOUNCE_MULT, 1);

      if (tb * 1000 < BOUNCE_MS) {
        requestAnimationFrame(frame);
        return;
      }

      setFaceVars(face, 0, 1, 0, 1);
    }

    requestAnimationFrame(frame);
  }

  function init(root) {
    var mobileQuery = window.matchMedia(MOBILE_MQ);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!mobileQuery.matches) return;

    var track = root.querySelector('[data-mso-track]');
    var sticky = root.querySelector('[data-mso-sticky]');
    if (!track || !sticky) return;

    var collage =
      root.querySelector('.one-million-sold__collage') ||
      root.querySelector('[data-mso-viewport]');
    if (!collage) return;

    var faces = Array.prototype.slice.call(root.querySelectorAll('[data-face]'));
    if (!faces.length) return;

    var group1 = faces.filter(function (f) {
      return f.getAttribute('data-face-group') === '1';
    });
    var group2 = faces.filter(function (f) {
      return f.getAttribute('data-face-group') === '2';
    });
    if (!group1.length && !group2.length) {
      var mid = Math.ceil(faces.length / 2);
      group1 = faces.slice(0, mid);
      group2 = faces.slice(mid);
    }

    faces.forEach(function (face) {
      face._msoStartRot = (Math.random() * 2 - 1) * START_ROT_MAX;
      face._msoRevealed = false;
      hideFace(face);
    });

    var active = false;
    var revealed1 = false;
    var revealed2 = false;

    var onScroll = null;
    var onResize = null;

    function revealGroup(groupFaces) {
      groupFaces.forEach(function (face, i) {
        if (face._msoRevealed) return;
        face._msoRevealed = true;
        window.setTimeout(function () {
          animateFace(face, face._msoStartRot);
        }, i * STAGGER_MS);
      });
    }

    function updateFromScroll() {
      if (!active) return;

      var top = collage.getBoundingClientRect().top;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var t1 = vh * GROUP1_TOP_RATIO;
      var t2 = vh * GROUP2_TOP_RATIO;

      if (top <= t2 && !revealed2) {
        revealed2 = true;
        revealGroup(group2);
      }

      if (top <= t1 && !revealed1) {
        revealed1 = true;
        revealGroup(group1);
      }
    }

    function onScrollHandler() {
      if (!active) return;
      updateFromScroll();
    }

    function measure() {
      track.style.height = '';
      updateFromScroll();
    }

    function showAllInstant() {
      revealed1 = true;
      revealed2 = true;
      faces.forEach(showFaceInstant);
    }

    function attachScroll() {
      onScroll = onScrollHandler;
      onResize = measure;

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);
    }

    function detachScroll() {
      if (onScroll) {
        window.removeEventListener('scroll', onScroll);
        onScroll = null;
      }
      if (onResize) {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
        onResize = null;
      }

      track.style.height = '';
    }

    function enableInteractive() {
      if (active) return;

      active = true;
      root.classList.remove('one-million-sold--reduced');
      measure();
      attachScroll();
      updateFromScroll();
    }

    function enableReduced() {
      active = false;
      detachScroll();
      root.classList.add('one-million-sold--reduced');
      showAllInstant();
    }

    function teardown() {
      active = false;
      detachScroll();
      root.classList.remove('one-million-sold--reduced');
    }

    if (reducedMotion.matches) {
      enableReduced();
    } else {
      enableInteractive();
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function (e) {
        if (!e.matches) {
          teardown();
        } else if (!reducedMotion.matches) {
          enableInteractive();
        }
      });
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', function (e) {
        if (e.matches) {
          enableReduced();
        } else if (mobileQuery.matches) {
          enableInteractive();
        }
      });
    }
  }

  function start() {
    document.querySelectorAll('[data-one-million-sold]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
